'use client';
import React, { JSX, type FC } from 'react';
import styles from './index.module.scss';
import Link from 'next/link';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';

export const Header: FC = (): JSX.Element => {
  const [scrolled, setScrolled] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      className={clsx(
        styles.headerContainer,

        {
          [styles.scrolled]: scrolled,
        }
      )}
    >
      <Link
        href={'/'}
        className={clsx(styles.logo, { [styles.scrolled]: scrolled })}
      >
        Karen Oude Alink
      </Link>

      <ul>
        <li>
          <Link
            href={'/work'}
            className={clsx({ [styles.active]: pathname === '/work' })}
          >
            Work
          </Link>
        </li>
        <li>
          <Link
            href={'/biography'}
            className={clsx({
              [styles.active]: pathname === '/biography',
            })}
          >
            Biography
          </Link>
        </li>
        <li>
          <Link
            href={'/contact'}
            className={clsx({
              [styles.active]: pathname === '/contact',
            })}
          >
            Contact
          </Link>
        </li>
      </ul>
    </div>
  );
};
